import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { PlatformSectionService } from '../platform-section.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-edit-platform-section',
  templateUrl: './edit-platform-section.component.html',
  styleUrls: ['./edit-platform-section.component.scss']
})
export class EditPlatformSectionComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name),
    slug: new FormControl(this.data.slug),
    observations: new FormControl(''),
    active_message: new FormControl(''),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditPlatformSectionComponent>,
    private platformSectionService: PlatformSectionService, 
    private notificationService: NotificationService,
    private authService: AuthService) {
      this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.platformSectionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedSectionData = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observations')?.value,
      active_message: this.form.get('active_message')?.value,
      id: this.data.id,
    };

    this.platformSectionService.updatePlatformSection(updatedSectionData)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: () => {
        this.dialogRef.close({success:true})
      },
      error: (err) => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon)
      }
    })
  }
}
